<template>
  <app-main-layout>
    <!--  -->
    <!-- Main Left Menu  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <!-- Main Top Menu -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-page-header nav-title> transactions </el-page-header>
        </template>
        <template v-slot:center>
          <span>
            <!-- Search -->
          </span>
        </template>
        <template v-slot:right>
          <!-- Other buttons -->
        </template>
      </app-top-nav>
    </template>
    <!--  -->
    <!-- Main Content -->
    <template v-slot:main>
      <!--  -->
      <!-- Charts -->
      <!--  -->
      <!-- Loaded transactions -->
      <div app-main-content>
        <TransactionsList :loading="loading"  :transactions="transactions"></TransactionsList>
      </div>
    </template>
    <!--  -->
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import TransactionsList from "./components/transactions-list.component.vue";

@Options({
  components: { TransactionsList },

})
export default class extends Vue {
  /**
   * @returns transactions
   */
  get transactions() {
    return this.$store.state.transactions.transactions;
  }

  /**
   * @returns transactions
   */
  get loading() {
    return this.$store.state.transactions.loading;
  }

  mounted() {
    this.$store.dispatch("transactions/fetch");
  }
}
</script>

<style lang="scss"></style>
